import { render, staticRenderFns } from "./ClubSuggestion.vue?vue&type=template&id=dbcf796c&scoped=true&"
import script from "./ClubSuggestion.vue?vue&type=script&lang=js&"
export * from "./ClubSuggestion.vue?vue&type=script&lang=js&"
import style0 from "./ClubSuggestion.vue?vue&type=style&index=0&id=dbcf796c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbcf796c",
  null
  
)

export default component.exports